export default __webpack_public_path__ + "static/media/icon-motorista.c3176b84.png";